import { render, staticRenderFns } from "./PatchCausesTemplate.vue?vue&type=template&id=0ec71b72"
import script from "./PatchCausesTemplate.vue?vue&type=script&lang=js"
export * from "./PatchCausesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports